<template>
  <avs-chip
    class="min-width-120"
    color="success"
    icon="mdi-checkbox-multiple-marked-circle"
    iconColor="white"
    text-color="white"
  >
    {{ $t("Approuvé") }}
  </avs-chip>
</template>

<script>
export default {
  name: "ApprovedChip"
}
</script>
